// PassesPaymentsCard.js
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Alert, Card, CardBody, Table } from "reactstrap";
import SimpleBar from "simplebar-react";
import { Link } from "react-router-dom";
import avatar from "../../../assets/images/avatar-5.jpg";
import { get } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import Placeholder from "../../../assets/images/Placeholder.gif";
const PassesPayments = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await get(`${endpoints.pass}/authorize/list`);
      if (response && response.data) {
        setData(response.data.data || []);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  const formatNumber = (num) => {
    if (num >= 1000000000) {
      return (num / 1000000000).toFixed(2) + "B";
    } else if (num >= 1000000) {
      return (num / 1000000).toFixed(2) + "M";
    } else if (num >= 1000) {
      return (num / 1000).toFixed(2) + "K";
    }
    return num.toFixed(2);
  };
  return (
    <Card className="rounded-4 mb-2">
      <CardBody>
        <div className="float-end">
          <span className="ff-sora font-size-16 fw-bold secondary-black">
            <Link
              to="/gym-payout"
              className="ff-sora font-size-16 fw-bold secondary-black"
            >
              View All
            </Link>
          </span>
        </div>
        <span className="ff-sora font-size-16 fw-normal primary-black">
          Passes Payments
        </span>

        <div
          className="table-responsive rounded-4 "
          style={{ height: "350px" }}
        >
          {loading ? (
            <div className="d-flex justify-content-center align-items-center">
              <div
                className="spinner-border"
                style={{
                  width: "3rem",
                  height: "3rem",
                  color: "#3BABA6",
                }}
                role="status"
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : error ? (
            <Alert
              color="danger"
              className="text-center ff-sora font-size-14 secondary-black fw-normal"
            >
              {error}
            </Alert>
          ) : data.length === 0 ? (
            <>
              <tr>
                <td
                  colSpan="3"
                  className="text-center ff-sora font-size-16 fw-normal"
                >
                  <img
                    src={Placeholder}
                    alt="Placeholder"
                    className="object-fit-contain image-fluid h-25 w-25 rounded-3 me-2"
                  />
                </td>
              </tr>
              <tr>
                <td
                  colSpan="3"
                  className="text-center border-0 ff-sora font-size-16 fw-normal"
                >
                  No Record Found!
                </td>
              </tr>
            </>
          ) : (
            <Table className="table-borderless table-centered table-nowrap ">
              <thead>
                <tr className="ff-sora font-size-14 primary-black fw-bold">
                  <th>Id</th>
                  <th>Purchased By</th>
                  <th>Pass Name</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {data.map((user, index) => (
                  <tr key={index}>
                    <td className="ff-sora font-size-14 secondary-black fw-normal">
                      {index + 1}
                    </td>
                    <td>
                      <div className="d-flex align-items-center">
                        <div>
                          <h6 className="ff-sora font-size-14 secondary-black fw-normal ">
                            {user.userDetail.firstName}
                            {user.userDetail.lastName}
                          </h6>
                        </div>
                      </div>
                    </td>
                    <td className="ff-sora badge font-size-14 secondary-black fw-normal">
                      {user.passDetail.name}
                    </td>
                    <td>
                      <span
                        className={`font-size-14 ff-sora secondary-black py-2 px-2`}
                      >
                        ${formatNumber(user.passDetail.price)}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </div>
      </CardBody>
    </Card>
  );
};

export default PassesPayments;
